import { render, staticRenderFns } from "./Treat.vue?vue&type=template&id=13b99747&scoped=true"
import script from "./Treat.vue?vue&type=script&lang=js"
export * from "./Treat.vue?vue&type=script&lang=js"
import style0 from "./Treat.vue?vue&type=style&index=0&id=13b99747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b99747",
  null
  
)

export default component.exports